export function PrivacyPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        minHeight: '100dvh',
        background: 'linear-gradient(155deg, #07070d 0%, #0b0b16 35%, #080812 100%)',
        fontFamily: '"DM Sans", sans-serif',
        color: '#e8e4dc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        overflowX: 'hidden',
        padding: 'clamp(24px, 5vh, 40px) 24px',
      }}
    >
      {/* Ambient orbs */}
      <div
        style={{
          position: 'fixed',
          top: '15%',
          left: '8%',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(255,107,43,.025) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift 25s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: '10%',
          right: '5%',
          width: 400,
          height: 400,
          background: 'radial-gradient(circle, rgba(78,205,196,.02) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift2 30s ease-in-out infinite',
        }}
      />

      <div style={{ maxWidth: 600, width: '100%', zIndex: 1 }}>
        <a
          href="/"
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 12,
            color: '#555',
            textDecoration: 'none',
            letterSpacing: 1,
          }}
        >
          &larr; back
        </a>

        <h1
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 'clamp(20px, 4vw, 28px)',
            fontWeight: 700,
            letterSpacing: 2,
            margin: '32px 0 8px',
          }}
        >
          privacy policy
        </h1>

        <p style={{ fontSize: 12, color: '#555', margin: '0 0 32px' }}>
          Last updated: February 2, 2025
        </p>

        <div style={{ lineHeight: 1.8, color: '#aaa', fontSize: 14 }}>
          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>The short version</h2>
            <p style={{ margin: 0 }}>
              We don't sell your data. We don't store your messages. Pulse is ephemeral by design.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>What we don't collect</h2>
            <p style={{ margin: 0 }}>
              Messages are held in memory only for the duration of active connections and are never
              written to disk or any database. When the last person leaves a room, everything is gone.
              There is no message history, no logs, no archive. We do not run analytics or tracking scripts.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Local storage</h2>
            <p style={{ margin: 0 }}>
              Pulse saves a small number of preferences in your browser's localStorage to
              remember your display name, chosen color, sound preference, and text scale setting.
              This data never leaves your browser.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Infrastructure</h2>
            <p style={{ margin: 0 }}>
              Pulse is hosted on Cloudflare Workers. Cloudflare may process standard connection
              metadata (IP addresses, request headers) as part of normal network operations.
              See{' '}
              <a
                href="https://www.cloudflare.com/privacypolicy/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#ff6b2b', textDecoration: 'none' }}
              >
                Cloudflare's privacy policy
              </a>{' '}
              for details.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Data selling</h2>
            <p style={{ margin: 0 }}>
              We will never sell, rent, or trade your personal information to third parties. Period.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Changes</h2>
            <p style={{ margin: 0 }}>
              We may update this policy as the service evolves. Material changes will be
              reflected in the "last updated" date above.
            </p>
          </section>

          <p style={{ margin: '32px 0 0', color: '#555', fontSize: 12 }}>
            See also: <a href="/terms" style={{ color: '#ff6b2b', textDecoration: 'none' }}>terms of service</a> · <a href="/credits" style={{ color: '#ff6b2b', textDecoration: 'none' }}>credits</a>
          </p>
        </div>
      </div>
    </div>
  );
}
